import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SocialAccount from './SocialAccountComponent';
import { accountCheck, generateLoginOTP } from '../actions/signinAction';
import { validateMobile, validateEmail } from '../../utils/inputValidator';
import AuthModalDesktop from './AuthModalDesktop';
import SignInWithOTP from './SignInWithOTPComponent';
import { parseSearch } from '../../modules/ajio-util/query';
import SignInSocial from './SignInSocial';
import AccCheckSocialUser from './AccCheckSocialUser';
import { createCookie } from '../../components/common/Cookie';
import ErrorMessage from '../../components/common/ErrorMessage';

import { isPhoneUserAgent } from '../../utils/loginUtil';
import { getProperty } from '../../modules/ajio-util/properties';
import {
  getReferralFeatureEnableFlag,
  getRefereeEnableFlag,
  getReferralAuthFeedbackTitle,
  getReferralAuthFeedbackSubTitle,
  getAjioMassEmailIdOptionalWeb
} from '../../Flags/selectors';
import { getSocialLogin } from '../../refresh/selectors/featureFlagsSelector';
import FloatingInput from './floating-input';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import luxeScreen from '../../refresh/constants/luxeScreenType';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import screen from '../../utils/pageType';
import { STREET_STORE } from '../../constants/constant';
import { getFeatureVariant } from '../../refresh/organism/ABFeature/Feature';

import {
  getRemovalLoginPasswordJson,
  getEnableRestorePhoneNumber
} from '../../refresh/selectors/featureFlagsSelector';
import { tncLink, privacyPolicyLink } from '../../refresh/constants/authentication.constants';
import Text from '../../refresh/atoms/Text';
import Button from '../../refresh/atoms/button';

class SignInComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.handleRestoreMobile = this.handleRestoreMobile.bind(this);
    this.state = {
      errorMsg: '',
      isMobNo: false,
      isEmail: false,
      username: '',
      ModalSignUp: false,
      pwdComponent: false,
      numVerify: false,
      showSocialOTP: false,
      socialLoginStatus: false,
      socialAccExists: false,
      loginStatusGA: '',
      userCred: '',
      forceUpdteMsg: false,
      twoFactorAuth: false
    };
    this.device = '';
  }

  componentWillMount() {
    if (!this.isMobile()) this.device = 'desktop';
    let { location = {}, location: { state = {} } = {}, userData = '' } = this.props;
    if (state.userData) {
      this.state.username = state.userData;
    }
    if (userData) {
      this.state.username = userData;
    }
  }

  componentDidMount() {
    let {
      location: { search = '' },
      metaData: { name = 'AJIO', sis = false } = {},
      newDesignLuxe,
      storeName
    } = this.props;

    if (search.includes('force')) {
      this.setState({
        forceUpdteMsg: true
      });
    }

   
    sessionStorage.removeItem('referrer');
    

    function getsearchParamsinIE(name) {
      var results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    }

    const params = new URLSearchParams(search);
    const referrer = params.get('referrer') || '';
    const loginSource = params.get('login_source') || '';
    const { login = {} } = luxeScreen;
    const { login_signup = {} } = screen;
    localStorage.setItem('LoginModelType', 'login/signup screen');
    gtmPagePush(
      'login/signup screen',
      newDesignLuxe ? login?.pageType || '' : login_signup?.pageType || '',
      window.__ENV__ || '',
      {
        Step: '1',
        source: referrer,
        login_source: loginSource,
        store: storeName
      }
    );
  }

  generateOTP(userInfo) {
    const { history = {}, queryString = '' } = this.props;
    let queryObj = parseSearch(queryString);
    let userData = userInfo;

    this.props.generateLoginOTP(userData, () => {
      if (this.props.otpSuccess) {
        let redirectURI = '/';
        redirectURI = queryObj.referrer ? redirectURI + queryObj.referrer : redirectURI;
        if (this.props.viewSiteAs == 'desktop') {
          // this.setState({
          //   otpClicked: true
          // });
        } else {
          let lastVisit = window.location.href;
          if (lastVisit.includes('?referrer')) {
            lastVisit = lastVisit.split('?').slice(1);
            lastVisit = lastVisit.join('?');
            history.push({
              pathname: '/login/otp',
              search: lastVisit,
              state: {
                userData
              }
            });
          } else {
            
            history.push({
              pathname: '/login/otp',
              search: redirectURI,
              state: {
                userData
              }
            });
          }
        }
      }
    });
  }

  // resendOTPforAuthCB = () => {
  //   this.generateOTP(decodeURIComponent(readCookie("uI")))
  // }

  handleSubmit(event, enableRestorePhoneNumber) {
    let { metaData: { name = 'AJIO', sis = false } = {} } = this.props;

    var usernameObj = {};
    event.preventDefault();
    if (!this.state.username.startsWith('0') && validateMobile(this.state.username.trim())) {
      this.setState({
        isMobNo: true,
        errorMsg: ''
      });
      usernameObj = { mobileNumber: this.state.username.trim() };
      gtmEventPush({
        page_type: 'user account screen',
        event: 'user_account_interactions',
        category: 'user account interactions',
        action: 'login type',
        label: 'mobileNumber'
      });
    }
    // else if (validateEmail(this.state.username.trim())) {
    //   this.setState({
    //     isEmail: true,
    //     errorMsg: ''
    //   });
    //   let email = this.state.username.toLowerCase().trim();
    //   usernameObj = { emailId: email };
    //   gtmEventPush({
    //     page_name: 'login signup screen',
    //     page_type: 'user account screen',
    //     event: 'user_account_interactions',
    //     category: 'user account interactions',
    //     action: 'login type',
    //     label: 'emailId'
    //   });
    // }
    else {
      let errorMessage;
      let valueEntered = this.state.username;
      if (valueEntered == '') {
        errorMessage = 'Please enter valid Mobile Number.';
      } else if (
        (/^\d+$/.test(valueEntered) && valueEntered.length !== 10) ||
        (/^\d+$/.test(valueEntered) && valueEntered.startsWith('0')) ||
        (valueEntered.substr(0, 3) == '+91' && /^\d+$/.test(valueEntered.substr(3)))
      ) {
        errorMessage =
          'Your mobile number should be of 10 digits. Please also ensure it does not start with 0 or +91.';
      } else if (valueEntered.substr(0, 1) == '+' && /^\d+$/.test(valueEntered.substr(1))) {
        errorMessage = 'Please enter a valid Mobile Number.';
      } else {
        errorMessage = 'Please enter a valid Mobile Number.';
      }
      this.setState({
        errorMsg: errorMessage,
        loginStatusGA: 'Failed'
      });
      gtmEventPush({
        page_type: 'user account screen',
        event: 'formError',
        category: 'formError',
        action: 'Welcome to AJIO',
        label: errorMessage
      });
    }
    if (
      this.state.username &&
      (validateEmail(this.state.username.toLowerCase().trim()) ||
        validateMobile(this.state.username.trim()))
    ) {
   
      this.props.accountCheck(usernameObj, (accountCheckRes) => {
        let userInputValue = Object.values(usernameObj)[0];
        createCookie('uI', userInputValue, 1);
        this.setState({
          userCred: userInputValue
        });

        const {
          history = {},
          metaData: { sis = false, name = '' } = {}
        } = this.props;
        const { success: accCheck = false, socialLogin = false } = accountCheckRes;

        if (accCheck) {
          this.setState({
            loginStatusGA: 'Success'
          });
          // Check if social LOGIN
          if (socialLogin == 'true' && socialLogin) {
            this.setState({
              socialAccExists: true,
              twoFactorAuth: false
            });
          } else {
            this.generateOTP(usernameObj);
            if (this.props.viewSiteAs == 'desktop' || this.device == 'desktop') {
              this.setState({
                pwdComponent: true
              });
            } else {
              history.push({
                pathname: '/login/password',
                search: this.props.queryString
              });
            }
          }
        } else if (this.props.viewSiteAs == 'desktop' || this.device == 'desktop') {
          this.setState({
            ModalSignUp: true
          });
        } else {
          window.location = `/signup${this.props.queryString}`;
        }
      });
    }
  }

  isMobile() {
    let mobileDevice = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      mobileDevice = true;
    }
    return mobileDevice;
  }

  thirdPartyLogin = loginStatus => {
    if (loginStatus == 'login') {
      this.setState({
        showSocialOTP: true,
        socialLoginStatus: true,
        twoFactorAuth: false
      });
    } else if (loginStatus == 'signup') {
      this.setState({
        numVerify: true,
        socialLoginStatus: true,
        twoFactorAuth: false
      });
    }
  };

  renderReferralHeader = (newDesignLuxe) => {
    // console.log("renderReferralHeader ++>", newDesignLuxe )
    if (
      getReferralFeatureEnableFlag(this.props.flags) &&
      getRefereeEnableFlag(this.props.flags) &&
      this.props.viewSiteAs !== 'desktop'
    ) {
      const { referrerDetails, refereeIncentive } = this.props;
      const { referralCode, referrerName } = referrerDetails;

      if (referralCode) {
        const ajioIcon = `${getProperty('imageBaseUrl')}/static/img/ajio.png`;
        const authHeaderBg = `${getProperty('imageBaseUrl')}/static/img/refresh-auth-bg.png`;
        const desktopStyle =
          this.device === 'desktop' ? { backgroundImage: `url(${authHeaderBg})` } : {};
        <img className="auth-header-new--ajio-icon" src={ajioIcon} alt="Ajio logo" />;
        return (
          <header className="auth-header-new" style={desktopStyle}>
            <img className="auth-header-new--ajio-icon" src={ajioIcon} alt="Ajio logo" />
            <h1 style={{ marginBottom: 0 }} className="title">
              {getReferralAuthFeedbackTitle(this.props.flags).replace(
                '_USERNAME_',
                referrerName || 'Your friend'
              )}
            </h1>
            {Number.isInteger(refereeIncentive) && refereeIncentive > 0 ? (
              <h3 className="subtitle">
                {getReferralAuthFeedbackSubTitle(this.props.flags).replace(
                  '_INCENTIVE_',
                  refereeIncentive
                )}
              </h3>
            ) : null}
          </header>
        );
      }
    }

    return this.state.socialLoginStatus ? null : (
      <h1 role="heading" aria-level={2}>
        Welcome to{' '}
        <span className={newDesignLuxe ? 'welcome-text' : ''}>
          {' '}
          {'AJIO'}
          {`${newDesignLuxe ? ' LUXE' : ''}`}{' '}
        </span>
      </h1>
    );
  };

  setSocialAccExists = () => {
    this.setState({ socialAccExists: true, twoFactorAuth: true });
  };

  handleRestoreMobile = () => {
    let { history } = this.props;
    history.push('/restore-phonenumber?utm_source=restore_your_mob&utm_medium=Web&utm_campaign=common_login_signup_screen');

    gtmEventPush({
      page_type: 'user account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'restore mobile number',
      label: 'click here'
    });
    // Segment Push event
    segmentEventPush({
      screen_name: '',
      // page_type: 'user account screen',
      event: 'Restore Phone Number Clicked',
      category: 'user account interactions',
      action: 'restore mobile number',
      label: 'click here'
    });
  };

  render() {
    const {
      viewSiteAs = '',
      metaData: {
        name = 'AJIO',
        sis = false,
        parentUrl = 'https://www.ajio.com',
        httpError = {}
      } = {},
      queryString = '',
      newDesignLuxe,
      storeName,
      socialLoginEnabled = true
    } = this.props;
    const enableRestorePhoneNumber = getEnableRestorePhoneNumber(this.props?.flags);
    const socialSignUpScreenModal = localStorage.getItem('LoginModelType') === 'One Last Step';
    let { error: { errorType = '', origin = '', message = '', pageType = '' } = {} } = httpError;
    const isPhonePe = sessionStorage.getItem('phonepe') === 'true' || isPhoneUserAgent();
    // let errMsg = "";
    const continueBtnGA = `Continue button click - ${this.state.loginStatusGA}`;
    const ajioMassEmailIdOptional =
      getAjioMassEmailIdOptionalWeb(this.props.flags) &&
      storeName === STREET_STORE &&
      getFeatureVariant('email-is-optional') !== '0';

    const loginRestoreMessageFromFirebase = getRemovalLoginPasswordJson(this.props?.flags);

    let loginRestoreMessage =
      loginRestoreMessageFromFirebase?.login_restore_phone_number_message ||
      'Email based login is no longer available. Please click here to restore your mobile number.';
    let loginRestorePhoneNumberMessage = loginRestoreMessage.replace(
      'click here',
      `<span class='link'><strong>click here</strong></span>`
    );

    if (this.state.socialAccExists) {
      return (
        <AccCheckSocialUser
          viewSiteAs={this.device}
          userCred={this.state.userCred}
          queryString={queryString}
          twoFactorAuth={this.state.twoFactorAuth}
        />
      );
    }
    if (this.state.ModalSignUp) {
      // && !this.props.accCheck
      return (
        <AuthModalDesktop
          destSrc="signup"
          viewSiteAs={viewSiteAs}
          setSocialAccExists={this.setSocialAccExists}
        />
      );
    } else if (this.state.pwdComponent) {
      return (
        <AuthModalDesktop
          destSrc="login/otp"
          viewSiteAs={viewSiteAs}
          userCred={this.state.userCred}
        />
      );
    } else {
      return (
        <div className="signin-container">
          <form
            className={`${newDesignLuxe ? 'luxe-newdesign' : ''} login-form num-email-form`}
            onSubmit={e => this.handleSubmit(e, enableRestorePhoneNumber)}
            data-ga-event-category="Login"
            data-ga-event-action={`Welcome to AJIO `}
            data-ga-event-label="Screen Launch"
          >
            {this.renderReferralHeader(newDesignLuxe)}
            { !isPhonePe && socialLoginEnabled && (
              <SocialAccount
                socialSignIn={this.thirdPartyLogin}
                viewSiteAs={this.device}
                queryString={queryString}
                setSocialAccExists={this.setSocialAccExists}
                callPageLoad={false}
              />
            )}
            {this.state.socialLoginStatus ? null : (
              <div>
                {newDesignLuxe ? (
                  <div className={`${newDesignLuxe ? 'signinInputWrap' : ''}`}>
                    <label htmlFor="mobileNumber">
                      Enter Mobile Number <span aria-hidden='true'>{ajioMassEmailIdOptional ? '' : '*'}</span>
                    </label>
                    <FloatingInput
                      id="mobileNumber"
                      floatingText={'Enter mobile number'}
                      type="tel"
                      name="username"
                      error={this.state.errorMsg}
                      size="32"
                      maxLength="254"
                      // autoFocus
                      value={this.state.username}
                      onChange={e => this.setState({ username: e.target.value })}
                      placeholder="  "
                      aria-required={!ajioMassEmailIdOptional}
                      role="textbox"
                      ariaDescribedBy='error-msg-floating'
                    />
                    <div id="error-msg-floating" className="error-msg" aria-live='polite'>
                      {this.state.errorMsg}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {newDesignLuxe ? (
                  ''
                ) : (
                  <div>
                    <label htmlFor="mobileNumber">
                      Enter Mobile Number <span aria-hidden='true'>{ajioMassEmailIdOptional ? '' : '*'}</span>
                    </label>
                    <input
                      id="mobileNumber"
                      type={enableRestorePhoneNumber ? 'tel' : 'text'}
                      name="username"
                      size="32"
                      className={enableRestorePhoneNumber ? 'username remove-phonenumber-flownumberfield': 'username'}
                      maxLength="254"
                        // autoFocus
                      value={this.state.username}
                      onChange={e => {
                        const digitsOnly = e.target.value.replace(/\D/g, '');
                        this.setState({ username: digitsOnly });
                      }}
                      aria-required={!ajioMassEmailIdOptional}
                      role="textbox"
                      autoComplete='tel'
                      aria-label="Enter 10 digit mobile number. It should not start with 0 or plus 91"
                      aria-describedby='error-msg-input'
                    />
                    <div id="error-msg-input" className="error-msg" aria-live='polite'>
                      {this.state.errorMsg}
                    </div>
                  </div>
                )}

                <div>
                  <input
                    type="submit"
                    className="login-btn"
                    value="Continue"
                    onClick={() => {
                      gtmEventPush({
                        page_type: 'user account screen',
                        event: 'user_account_interactions',
                        category: 'user account interactions',
                        action: 'Continue'
                      });
                    }}
                    data-ga-event-category="Login"
                    data-ga-event-action={`Welcome to AJIO`}
                    data-ga-event-label={continueBtnGA}
                  />
                </div>

                <div className="btn-action-txt">
                  <Text color="Dark_Grey">
                    {'By Signing In, I agree to '}
                    <Button variant="link" role="link" btnLabel="Terms & Conditions" size="sm" href={tncLink} />
                    {' and'}
                    <Button
                      variant="link"
                      role="link"
                      btnLabel="Privacy Policy"
                      size="sm"
                      href={privacyPolicyLink}
                    />
                  </Text>
                </div>

                {httpError.error &&
                Object.keys(httpError.error).length &&
                pageType == 'login-info' ? (
                  <div className="err-msg-blk">
                    <ErrorMessage message={message} />
                  </div>
                ) : null}
                {this.state.forceUpdteMsg ? (
                  <div className="err-msg-blk">
                    <ErrorMessage showCloseButton={false} message="You have been logged out" />
                  </div>
                ) : null}
              </div>
            )}
          </form>
          {!socialSignUpScreenModal && enableRestorePhoneNumber && (
            <div className="warning-msg-text-div">
              <div className="warning-msg-text">
                <div className="warning-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M2.625 15.001C2.325 15.001 2.0625 14.8885 1.8375 14.6635C1.6125 14.4385 1.5 14.176 1.5 13.876V4.12598C1.5 3.82598 1.6125 3.56348 1.8375 3.33848C2.0625 3.11348 2.325 3.00098 2.625 3.00098H15.375C15.675 3.00098 15.9375 3.11348 16.1625 3.33848C16.3875 3.56348 16.5 3.82598 16.5 4.12598V13.876C16.5 14.176 16.3875 14.4385 16.1625 14.6635C15.9375 14.8885 15.675 15.001 15.375 15.001H2.625ZM9 9.33848L2.625 5.15723V13.876H15.375V5.15723L9 9.33848ZM9 8.21348L15.3 4.12598H2.71875L9 8.21348ZM2.625 5.15723V4.12598V13.876V5.15723Z"
                      fill="#EFB027"
                    />
                  </svg>
                </div>
                <div className="warning-text">
                  <div
                    onClick={this.handleRestoreMobile}
                    tabIndex={0}
                    role="link"
                    dangerouslySetInnerHTML={{ __html: loginRestorePhoneNumberMessage }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountCheck: (formData, callback) => {
      dispatch(accountCheck(formData, callback));
    },
    generateLoginOTP: (mobile, callbackOtp) => {
      dispatch(generateLoginOTP(mobile, callbackOtp));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const {
    signInReducer = {},
    httpError = {},
    metaData = {},
    referAndEarn = {},
    flags = {}
  } = state;
  const { success = false, emailId = '', socialLogin = false } = signInReducer;
  const { referrerDetails = {}, refereeIncentive = 0 } = referAndEarn;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const socialLoginEnabled = getSocialLogin(flags);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    accCheck: success,
    emailId,
    socialLogin,
    httpError,
    metaData,
    referrerDetails,
    refereeIncentive,
    flags,
    storeName,
    socialLoginEnabled
  };
};

export default SignInComponent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignInComponent)
);
